import { NgModule } from "@angular/core";

import { DigitLimitingService } from "./digit-limiting.service";
import { FileSizeService } from "./file-size.service";
import { HumanizeService } from "./humanize.service";
import { ShortNumberService } from "./short-number.service";

@NgModule({
  providers: [
    DigitLimitingService,
    FileSizeService,
    ShortNumberService,
    HumanizeService
  ]
})
export class PipeServicesModule {}
